import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.section`
  position: relative;
  z-index: 2;
  background: #160f30;
  background-image: url('/images/main-pc-banner-bg.jpg');
  background-position-x: 50%;
  background-size: 2400px 330px;
  background-repeat: no-repeat;
  height: 330px;
  width: 100%;
  padding-top: 87px;
  transform: translateX(-50%);
  margin-left: 50%;

  ${({ theme }) => theme.media.tablet} {
    width: 100%;
  }
  ${({ theme }) => theme.media.mobile} {
    background-image: url('/images/main-mobile-banner-bg.jpg');
    height: 280px;
    background-size: 1534px 280px;
    padding-top: 50px;
  }

  /* SearchBox 공통 컴퍼넌트 스타일 커스텀 */
  & > .search-box-wrapper {
    width: 580px;
    margin: 0 auto;
    float: none;
    margin-top: 20px;
    padding: 0 24px;
    height: 50px;
    background: ${({ theme }) => theme.colors.white100};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
    border-radius: 60px;
    position: relative;
    display: flex;
    align-items: center;

    ${({ theme }) => theme.media.mobile} {
      width: 350px;
      height: 48px;
    }
  }
`;

export const InputWrapper = styled.div<{ isSearching: boolean }>`
  width: 580px;
  height: 50px;
  position: relative;
  display: flex;
  border-radius: 25px;
  border: none;
  padding: 0 28px;
  cursor: pointer;
  align-items: center;
  background: ${({ theme }) => theme.colors.white100};
  margin: 0 auto;
  margin-top: 20px;

  ${({ isSearching }) =>
    isSearching &&
    css`
      border-radius: 25px 25px 0px 0px;
      filter: drop-shadow(4px 4px 20px rgba(0, 0, 0, 0.15));
    `}

  > span {
    margin-right: 24px;
    display: flex;
    align-items: center;

    img {
      width: 19px;
      height: 19px;
    }
  }

  ${({ theme }) => theme.media.mobile} {
    width: 343px;
  }
`;

export const inlineCss = css`
  width: 100%;
  position: unset;
`;

export const inputCss = css``;

export const Input = styled.input`
  width: 100%;
  background: none;
  border: none;
  outline: none;

  ${getFontStyle('midium150_B1')}
`;

export const listCss = css`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
  border-radius: 0px 0px 25px 25px;
  box-shadow: none;
`;
